import React from "react";
import { useTranslation } from "react-i18next";

const UsageGuidelines = (props) => {
    const styles = props.styles;
    const { t } = useTranslation();

    return(
        <>
            <p style={styles.tosContentLastChangedStyle}>{t('termsOfServicePage.lastChanged')}</p>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.usageGuidelines.description')}</p>
            <ul>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li1')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li2')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li3')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li4')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li5')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li6')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.usageGuidelines.termList.li7')}</p></li>
            </ul>
            <p style={styles.tosContentDescriptionStyle}><b>{t('termsOfServicePage.usageGuidelines.warning')}</b></p>
            <h3 style={styles.tosContentTitleStyle}>{t('termsOfServicePage.changesDisclaimer.title')}</h3>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p1')}</p>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p2')}</p>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p3')}</p>
        </>
    )
}

export default UsageGuidelines